/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SignUpContainer_auth = {
    readonly integrations: {
        readonly local: {
            readonly enabled: boolean;
            readonly targetFilter: {
                readonly stream: boolean;
            };
            readonly allowRegistration: boolean;
        };
        readonly facebook: {
            readonly enabled: boolean;
            readonly targetFilter: {
                readonly stream: boolean;
            };
            readonly allowRegistration: boolean;
        };
        readonly google: {
            readonly enabled: boolean;
            readonly targetFilter: {
                readonly stream: boolean;
            };
            readonly allowRegistration: boolean;
        };
        readonly oidc: {
            readonly enabled: boolean;
            readonly targetFilter: {
                readonly stream: boolean;
            };
            readonly allowRegistration: boolean;
        };
    };
    readonly " $fragmentRefs": FragmentRefs<"SignUpWithOIDCContainer_auth" | "SignUpWithGoogleContainer_auth" | "SignUpWithFacebookContainer_auth">;
    readonly " $refType": "SignUpContainer_auth";
};
export type SignUpContainer_auth$data = SignUpContainer_auth;
export type SignUpContainer_auth$key = {
    readonly " $data"?: SignUpContainer_auth$data;
    readonly " $fragmentRefs": FragmentRefs<"SignUpContainer_auth">;
};



const node: ReaderFragment = (function () {
    var v0 = [
        ({
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
        } as any),
        ({
            "alias": null,
            "args": null,
            "concreteType": "AuthenticationTargetFilter",
            "kind": "LinkedField",
            "name": "targetFilter",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "stream",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any),
        ({
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowRegistration",
            "storageKey": null
        } as any)
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "SignUpContainer_auth",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "AuthIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "LocalAuthIntegration",
                        "kind": "LinkedField",
                        "name": "local",
                        "plural": false,
                        "selections": (v0 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacebookAuthIntegration",
                        "kind": "LinkedField",
                        "name": "facebook",
                        "plural": false,
                        "selections": (v0 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "GoogleAuthIntegration",
                        "kind": "LinkedField",
                        "name": "google",
                        "plural": false,
                        "selections": (v0 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "OIDCAuthIntegration",
                        "kind": "LinkedField",
                        "name": "oidc",
                        "plural": false,
                        "selections": (v0 /*: any*/),
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SignUpWithOIDCContainer_auth"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SignUpWithGoogleContainer_auth"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SignUpWithFacebookContainer_auth"
            }
        ],
        "type": "Auth",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '0783fc0fb0d32b6b35614e3a5ad00ff7';
export default node;
